import { useSegments } from "expo-router";
export function useSiteSection() {
	//this always return (tabs) or (members-area

	var segments = useSegments();
	if (segments.length <= 2) {
		return "/";
	}
	if (segments[2] == "(members-area)" && segments.length > 3) {
		return "/" + segments[3];
	}
	return "/" + segments[2];
}
export function useIsAdminSection() {
	var segments = useSegments();
	if (segments.length == 0) {
		return false;
	}

	if (segments.length > 3 && segments[2] == "(members-area)" && segments[3] == "admin") {
		return true;
	}
	return false;
}

export function useSiteRegion() {
	if (typeof window === "undefined") {
		return null;
	}

	const hostname = window.location.hostname;

	if (hostname.includes("abcopro.co.nz")) {
		return "nz";
	}

	if (hostname.includes("abcopro.com.au")) {
		return "au";
	}

	return "au";
}
